import { useDealershipSettings } from '../contexts/settingsContext';
import { useUserSettings } from '../contexts/userSettingsValue';

/**
 * The margin floor (%) the signed-in user's unit margin tile measures
 * against (docs/decisions/role-presets.md, decision 9).
 *
 * With a personal floor set, the server's `margin.effective_floor_pct`
 * (the personal value inside the dealership's allowed range, else the
 * dealership value). Without one, the dealership value from the dealership
 * settings in view, which stay in step with the data (P2-2) even when an
 * admin changes the floor during the session.
 */
export default function useMarginFloorPct() {
    const { marginFloorPct } = useDealershipSettings();
    const { margin } = useUserSettings();
    const personal = margin?.user_floor_pct;
    const effective = margin?.effective_floor_pct;
    if (personal !== null && personal !== undefined && typeof effective === 'number' && Number.isFinite(effective)) {
        return effective;
    }
    return marginFloorPct;
}
